import api from "@/api/api";
import type {
  ForumConfig,
  ForumDeleteResponse,
  ForumMyRegistrations,
  ForumRow,
  ForumStoreResponse,
} from "@/types/forum";

/**
 * Service du Forum AGCO (app — concessionnaires authentifiés).
 */
class ForumService {
  /** Libellés + contenu éditorial (présentation / programme). */
  async getConfig(): Promise<ForumConfig> {
    const response = await api.get("/v1/forum/config");
    return response.data;
  }

  /** Inscrits de l'utilisateur connecté (préremplissage / modification). */
  async getMyRegistrations(): Promise<ForumMyRegistrations> {
    const response = await api.get("/v1/forum/my-registrations");
    return response.data;
  }

  /** Enregistre / modifie les inscrits de l'utilisateur connecté. */
  async submit(rows: ForumRow[]): Promise<ForumStoreResponse> {
    const response = await api.post("/v1/forum/registrations", { rows });
    return response.data;
  }

  /** Supprime immédiatement un inscrit enregistré de l'utilisateur connecté. */
  async remove(id: number): Promise<ForumDeleteResponse> {
    const response = await api.delete(`/v1/forum/registrations/${id}`);
    return response.data;
  }
}

export default new ForumService();
